import { RefObject } from 'react';
import { Button, Stack } from '@mui/material';
import Iconify from 'src/components/iconify';

export interface FormListActionButtonsProps {
  /** 파일 input ref */
  fileInputRef: RefObject<HTMLInputElement>;
  /** 다운로드 핸들러 */
  onDownload: () => void;
  /** 업로드 버튼 클릭 핸들러 */
  onClickUpload: () => void;
  /** 파일 선택 핸들러 */
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /** 추가 버튼 클릭 핸들러 */
  onAdd: () => void;
  /** 추가 버튼 라벨 */
  addLabel: string;
  /** 일괄 등록 버튼 클릭 핸들러 (선택) */
  onBulkRegister?: () => void;
  /** 일괄 등록 버튼 라벨 */
  bulkRegisterLabel?: string;
}

/**
 * 리스트형 폼 필드용 액션 버튼 공통 컴포넌트
 * - 엑셀 다운로드/업로드
 * - 일괄 등록 (선택)
 * - 항목 추가
 */
function FormListActionButtons({
  fileInputRef,
  onDownload,
  onClickUpload,
  onUpload,
  onAdd,
  addLabel,
  onBulkRegister,
  bulkRegisterLabel = '일괄 등록',
}: FormListActionButtonsProps) {
  return (
    <Stack direction="row" spacing={1} justifyContent="flex-end">
      <Button
        type="button"
        variant="outlined"
        size="small"
        startIcon={<Iconify icon="eva:download-fill" />}
        onClick={onDownload}
      >
        엑셀 다운로드
      </Button>
      <Button
        type="button"
        variant="outlined"
        size="small"
        startIcon={<Iconify icon="eva:upload-fill" />}
        onClick={onClickUpload}
      >
        엑셀 업로드
      </Button>
      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx,.xls"
        style={{ display: 'none' }}
        onChange={onUpload}
      />
      {onBulkRegister && (
        <Button
          type="button"
          variant="outlined"
          size="small"
          startIcon={<Iconify icon="mdi:calendar-multiselect" />}
          onClick={onBulkRegister}
        >
          {bulkRegisterLabel}
        </Button>
      )}
      <Button
        type="button"
        size="small"
        variant="contained"
        startIcon={<Iconify icon="eva:plus-fill" />}
        onClick={onAdd}
      >
        {addLabel}
      </Button>
    </Stack>
  );
}

export default FormListActionButtons;
